<template>
    <template v-if="message">
       <div v-html="message"></div>
    </template>
    <div class="text-center loading-spinner">
        <template v-if="showBrandLogo">
            <img :alt="companyName + ' logo'" class="my-5" :src="companyLogoPath" style="max-width:100px; height:auto;" :title="companyName + ' logo'"/>
        </template>

        <template v-if="image">
            <div class="mb-3">
                <img :src="image" alt="" class="loading-animation-image" style="max-width: 150px; height: auto;" />
            </div>
        </template>

        <!-- dots -->
        <template v-if="animationType === 'dots'">
            <div class="loading-dots" role="status">
                <span class="loading-dot"></span>
                <span class="loading-dot"></span>
                <span class="loading-dot"></span>
                <span class="visually-hidden">Loading...</span>
            </div>
        </template>

        <!-- bar -->
        <template v-else-if="animationType === 'bar'">
            <div class="loading-bar-container" role="status">
                <div class="loading-bar"></div>
                <span class="visually-hidden">Loading...</span>
            </div>
        </template>

        <!-- none: no animation shown -->
        <template v-else-if="animationType === 'none'"></template>

        <!-- spinner (default fallback for 'spinner' or any unknown type) -->
        <template v-else>
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </template>

        <!-- TODO -- get the actual affiliate name/logo as we do for Lumen  -->
<!--        <div class="mt-5" v-if="showAffiliateLogo">-->
<!--            <small>In partnership with</small><br>-->
<!--            <img alt="Logo" class="my-4" src="/images/prets-quebec-logo.jpg" style="max-width:100px; height:auto;" title="Logo"/>-->
<!--        </div>-->
    </div>
</template>

<script setup>

import { computed } from 'vue';

const props = defineProps({
    showBrandLogo: {
        type: Boolean,
        default: true,
    },
    showAffiliateLogo: {
        type: Boolean,
        default: false,
    },
    brandLogo: {
        type: Object,
        default: null,
    },
    message: {
        type: String,
        default: null,
    },
    image: {
        type: String,
        default: null,
    },
    animationType: {
        type: String,
        default: 'spinner',
    },
});

const companyName = computed(() => props.brandLogo?.name ?? 'CompareHub');
const companyLogoPath = computed(() => props.brandLogo?.logo_path ?? '/assets/images/compare-hub-logo.png');

</script>

<style scoped>
.loading-dots {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.loading-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: var(--bs-primary, #0d6efd);
    animation: loading-dot-bounce 1.4s infinite ease-in-out both;
}

.loading-dot:nth-child(1) {
    animation-delay: -0.32s;
}

.loading-dot:nth-child(2) {
    animation-delay: -0.16s;
}

@keyframes loading-dot-bounce {
    0%, 80%, 100% {
        transform: scale(0.4);
        opacity: 0.4;
    }
    40% {
        transform: scale(1);
        opacity: 1;
    }
}

.loading-bar-container {
    width: 200px;
    height: 4px;
    background-color: #e9ecef;
    border-radius: 2px;
    overflow: hidden;
    margin: 0 auto;
}

.loading-bar {
    width: 40%;
    height: 100%;
    background-color: var(--bs-primary, #0d6efd);
    border-radius: 2px;
    animation: loading-bar-slide 1.5s infinite ease-in-out;
}

@keyframes loading-bar-slide {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(350%);
    }
}
</style>
